/**
 * GitHub OAuth & Onboarding API
 */

import { apiFetch } from './config';

export interface GitHubStatus {
  connected: boolean;
  github_username: string | null;
  projects_connected: number;
}

export interface GitHubRepo {
  name: string;
  full_name: string;
  language: string | null;
  default_branch: string;
  private: boolean;
  html_url: string;
  updated_at: string;
}

export interface PatternDiscovery {
  discovery_id?: string;
  discovery_type: string;
  pattern_name: string;
  pattern_description: string;
  confidence: number;
  evidence: unknown[];
  status?: string;
}

export interface ReviewResult {
  patterns_created: number;
  patterns_rejected: number;
}

export const githubApi = {
  /**
   * Get GitHub connection status
   */
  getStatus: async () => {
    return apiFetch<GitHubStatus>('/api/github/status');
  },

  /**
   * Start OAuth flow - get authorization URL
   */
  startOAuth: async () => {
    return apiFetch<{ authorization_url: string; state: string }>('/api/github/oauth/start');
  },

  /**
   * List user's GitHub repos
   */
  listRepos: async () => {
    return apiFetch<{ repos: GitHubRepo[] }>('/api/github/repos');
  },

  /**
   * Discover patterns from a repo
   */
  discoverPatterns: async (project_id: string, owner: string, repo: string, branch?: string) => {
    return apiFetch<{ discoveries: PatternDiscovery[]; count: number }>('/api/github/discover', {
      method: 'POST',
      body: JSON.stringify({ project_id, owner, repo, branch }),
    });
  },

  /**
   * Submit pattern approvals/rejections
   */
  reviewPatterns: async (project_id: string, approvals: { discovery_id: string; approved: boolean }[]) => {
    return apiFetch<ReviewResult>('/api/github/patterns/review', {
      method: 'PUT',
      body: JSON.stringify({ project_id, approvals }),
    });
  },
};
